import { FilterSelection, FiltersInPricesValues, PricesFilterType } from '@/scopes/prices/domain/filters/types'
import { PriceTableAnalyticsWithBrand } from '@/scopes/prices/domain/types'
import * as React from 'react'

interface InitPricesParams {
  accoId: string
  contextItemId: string
  bookingGateId: string
  analytics: PriceTableAnalyticsWithBrand | null
  initialFilterSelection: FilterSelection
  promotedPriceId: string
}

interface SelectFilterParams {
  type: PricesFilterType
  selection: FiltersInPricesValues
}

interface PricesUseCasesContextType {
  initPrices: (params: InitPricesParams) => Promise<void>
  initPriceTable: () => Promise<void>
  selectFilter: (params: SelectFilterParams) => Promise<void>
  selectPrice: (priceId: string | null) => Promise<void>
  selectRoom: (roomNumber: string, roomId: string | null) => Promise<void>
  setOutboundRouteId: (routeId: string | null) => Promise<void>
  setInboundRouteId: (routeId: string | null) => Promise<void>
}

export const PricesUseCasesContext = React.createContext<PricesUseCasesContextType>({
  initPrices: async () => {},
  initPriceTable: async () => {},
  selectFilter: async () => {},
  selectPrice: async () => {},
  selectRoom: async () => {},
  setOutboundRouteId: async () => {},
  setInboundRouteId: async () => {},
})
